import React, {Component} from 'react';
import classnames from 'classnames';
import {inject, observer} from 'mobx-react'; // eslint-disable-line no-unused-vars

import SliderField from './sliderGroup/SliderField';

@inject('personaStore', 'templateStore')
@observer
export default class SliderGroup extends Component {
  state = {
    editing: false
  }

  componentDidMount() {
    document.addEventListener("click", this.viewMode);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.viewMode);
  }

  editMode = (e) => {
    if (!this.props.personaStore.isEditable)
      return;
    e.nativeEvent.stopImmediatePropagation();
    this.setState({editing: true});
  }

  viewMode = () => {
    this.setState({editing: false});
  }

  onSlideChange = (e) => {
    const {groupKey} = this.props;
    const {body, updateBody} = this.props.personaStore;
    const theChange = {};
    theChange[groupKey] = body[groupKey] || {};
    theChange[groupKey][e.target.name.toString()] = e.target.value;
    const newPersona = Object.assign({}, body, theChange);
    updateBody(newPersona);
  }

  render() {
    const {groupKey, personaStore, templateStore} = this.props;
    const {body, isEditable} = personaStore;
    const {editing} = this.state;
    const bodyGroup = body[groupKey] || {};
    const templateGroup = templateStore.selectedTemplate[groupKey];
    // We defined the keys here because I need to come up with a better way to have
    // default properties
    const keys = ["internet", "software", "mobile_apps", "social_network"];
    const groupClasses = classnames([
      {
        'editable': isEditable,
      }
    ]);
    return (
      <div className={groupClasses} onClick={this.editMode}>
        {keys.map((formKey) => {
           return (
             <SliderField
              key={formKey}
              formKey={formKey}
              value={bodyGroup[formKey] || templateGroup[formKey]}
              editing={editing}
              onChange={this.onSlideChange}
              {...this.props}
            />
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/technologyComfort/SliderGroup.jsx